import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import { delVideoInfo } from "../../../redux/slices/mainDataSlice";
import VideoAdd from "./VideoAdd";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

// import required modules
export default function VideoInfo({ videoInfo, setVideoInfo }) {
  const data = useSelector((state) => state.main.data?.videosData)?.filter(
    (item) => item.clinc_id == "1"
  );
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);
  const [videoAdd, setVideoAdd] = useState(false);
  const dispatch = useDispatch();
  return (
    videoInfo && (
      <>
        <div className="video-info-admin" data-aos="fade-in">
          <div
            className="content-layout"
            onClick={() => setVideoInfo(false)}
          ></div>
          <div className="add-icon" onClick={() => setVideoAdd(true)}>
            <lord-icon
              src="https://cdn.lordicon.com/jgnvfzqg.json"
              trigger="hover"
              className="img"
              style={{ width: "50px", height: "50px" }}
            ></lord-icon>
          </div>
          <Swiper
            pagination={{
              dynamicBullets: true,
            }}
            navigation={true}
            slidesPerView={"auto"}
            centeredSlides={true}
            spaceBetween={20}
            modules={[Pagination, Navigation]}
            className="container "
          >
            {data?.map((section) => (
              <>
                <SwiperSlide className="section">
                  <div className="image">
                    <video controls>
                      <source
                        src={`https://api.atharalfarasha.com/public/hakim/${section?.video_name}`}
                        type="video/mp4"
                      />
                      <source
                        src={`https://api.atharalfarasha.com/public/hakim/${section?.video_name}`}
                        type="video/webm"
                      />
                      <source
                        src={`https://api.atharalfarasha.com/public/hakim/${section?.video_name}`}
                        type="video/ogg"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div
                    className="del-icon"
                    onClick={() => dispatch(delVideoInfo(section?.id))}
                  >
                    <lord-icon
                      src="https://cdn.lordicon.com/skkahier.json"
                      trigger="hover"
                      className="img"
                      style={{ width: "50px", height: "50px" }}
                    ></lord-icon>
                  </div>
                  {/* <div className="data">
                    <div className="title">
                      <span>{section?.video_info}</span>
                    </div>
                  </div> */}
                </SwiperSlide>
              </>
            ))}
          </Swiper>
        </div>
        <VideoAdd setVideoAdd={setVideoAdd} videoAdd={videoAdd} />
      </>
    )
  );
}
